import { clamp } from "../core/math";

export const MAX_SIMULATION_FRAME_DELTA_SECONDS = 0.1;

export interface FrameTiming {
  /** Real foreground time used by the competitive clock. */
  readonly activeWallSeconds: number;
  /** Bounded time admitted to the fixed-step physics accumulator. */
  readonly simulationSeconds: number;
}

export function frameTiming(
  previousMilliseconds: number,
  currentMilliseconds: number,
): FrameTiming {
  if (
    !Number.isFinite(previousMilliseconds)
    || !Number.isFinite(currentMilliseconds)
    || previousMilliseconds <= 0
    || currentMilliseconds <= previousMilliseconds
  ) {
    return { activeWallSeconds: 0, simulationSeconds: 0 };
  }
  const activeWallSeconds = (currentMilliseconds - previousMilliseconds) / 1_000;
  return {
    activeWallSeconds,
    simulationSeconds: clamp(
      activeWallSeconds,
      0,
      MAX_SIMULATION_FRAME_DELTA_SECONDS,
    ),
  };
}
